// Firebase web API keys are *not* secrets — they're identifiers for a project,
// not access tokens. Security is enforced by Firebase security rules, not by
// keeping these values out of git. We still expose them via env vars so
// different deploys (dev, preview, prod) can target different Firebase
// projects without a code change. See .env.example and README.
export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? "AIzaSyAXL6ky257d4hVRgxv4UND-1_937LkHR6Q",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? "porrazirauki-d3f78.firebaseapp.com",
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL ?? "https://porrazirauki-d3f78.firebaseio.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "porrazirauki-d3f78",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? "porrazirauki-d3f78.appspot.com",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "194575381836",
    appId: process.env.REACT_APP_FIREBASE_APP_ID ?? "1:194575381836:web:5bf8e5316b337e10d30be9",
};
